import React, {useMemo} from 'react';
import PropTypes from 'prop-types';
import graphql from "babel-plugin-relay/macro";
import {DateCell} from "../../../components/common/advance-table/CustomCells";
import {useFragment} from "react-relay";
import {useUser} from "../../../hooks/useUser";
import {Card} from "react-bootstrap";
import CardTableHeader from "../../../components/common/headers/CardTableHeader";
import AdvanceTable from "../../../components/common/advance-table/AdvanceTable";
import AdvanceTablePagination from "../../../components/common/advance-table/AdvanceTablePagination";
import AdvanceTableWrapper from "../../../components/common/advance-table/AdvanceTableWrapper";
import NewPractitionerLanguageModal from "./NewPractitionerLanguageModal";
import EditPractitionerLanguageModal from "./EditPractitionerLanguageModal";
import DeleteModal from "../../../components/common/modals/DeleteModal";
import {useTableModals} from "../../../hooks/useTableModals";

const cols = [
    {accessor: 'language.name', Header: 'Language'},
    {accessor: 'seq', Header: 'Order'},
    {accessor: 'effectiveFrom', Header: "Effective From", Cell: DateCell},
    {accessor:'effectiveTo', Header:'Effective To', Cell: DateCell}
]
const PractitionerLanguages = ({practitionerId, languages, allLanguages, displayMode}) => {
    const deleteMutation = graphql`
    mutation PractitionerLanguagesDeleteMutation($id: ID!) {
        deleteNode(input: {id: $id}) {
            deletedNodeId @deleteRecord
            owner {
                ... on Practitioner {
                    id
                    languages {
                        id
                    }}}}}`
    const data = useFragment(graphql`
        fragment PractitionerLanguages_Languages on PractitionerLanguage @relay(plural:true) {
            id
            language {
                id
                name
                isoCode
                displayOrder
            }
            seq
            effectiveFrom
            effectiveTo
        }
    `,languages)
    const activeCols = useMemo(() => displayMode === "current" ? cols.slice(0, -2) : cols, [displayMode]);
    const {hasPermission} = useUser();
    const {selected, columns, newModal, editModal, deleteModal} = useTableModals(activeCols, "PractitionerLanguage.Update", "PractitionerLanguage.Delete");
    return (
        <>
            <AdvanceTableWrapper columns={columns}
                                 data={data}
                                 sortable
                                 pagination
                                 perPage={10}
            >
                <Card className={"mb-3"}>
                    <Card.Header>
                        <CardTableHeader onNewClick={newModal.onClick}
                                         title={"Languages"}
                                         table
                                         showNew={hasPermission("PractitionerLanguage.Create")} />
                    </Card.Header>
                    <Card.Body className={"p-0"}>
                        <AdvanceTable table
                                      headerClassName={"bg-200 text-900 text-nowrap align-middle"}
                                      rowClassName={"align-middle white-space-nowrap"}
                                      tableProps={{size: "sm", striped: true, className: "fs--1 mb-0 overflow-hidden"}}
                        />
                    </Card.Body>
                    <Card.Footer>
                        <AdvanceTablePagination table />
                    </Card.Footer>
                </Card>
            </AdvanceTableWrapper>
            <NewPractitionerLanguageModal showModal={newModal.showModal}
                                          onClose={newModal.onClose}
                                          languages={allLanguages}
                                          practitionerId={practitionerId}
            />
            {selected && <EditPractitionerLanguageModal showModal={editModal.showModal}
                                                        onClose={editModal.onClose}
                                                        selectedLanguage={selected}
                                                        languages={allLanguages}
            />}
            {selected && <DeleteModal mutation={deleteMutation} 
                                      onClose={deleteModal.onClose} 
                                      thingToDelete={"Language"} 
                                      showModal={deleteModal.showModal}
                                      id={selected.id}
            >
                <p>This cannot be undone.</p>
            </DeleteModal>}
        </>
    )
}
PractitionerLanguages.propTypes = {
    practitionerId: PropTypes.string.isRequired,
    allLanguages: PropTypes.array.isRequired,
    languages: PropTypes.array.isRequired
}
export default PractitionerLanguages